import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import HELPERS from '../../utils/helper';
import { ToastMessage, Toast, toastMsgConfig } from '../toast';
import apis from '../../config/apis';
import { ErrorMessageHandling } from '../error';
import { getClientConfig } from '../../config/clientConfig';
import './template12.css';

// Modern App-Style Template - Responsive across all devices
class EnquiryTemplate12 extends Component {
  constructor(props) {
    super(props);

    const clientConfig = getClientConfig(props.clientId);

    if (!clientConfig) {
      this.state = {
        loader: false,
        clientConfig: null,
        formData: {},
        errors: {},
        disabled: true,
        areas: [],
        courses: [],
      };
      return;
    }

    this.state = {
      loader: false,
      formData: {
        name: '',
        phone: '',
        email: '',
        area: '',
        course: '',
        message: ''
      },
      errors: {},
      disabled: false,
      areas: [],
      clientConfig: clientConfig,
      courses: clientConfig.courses,
      currentStep: 1,
      showWelcome: true
    };
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.fetchAreas();
    this.fetchCourses();
  }

  fetchAreas = async () => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*'
        }
      };

      const areasUrl = apis.getAreasUrl(clientConfig);
      const res = await HELPERS.ApiCall(areasUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data) {
        const result = res.data.result || res.data.data || res.data;
        const areas = [];

        if (Array.isArray(result)) {
          result.forEach(item => {
            if (item.areaList && Array.isArray(item.areaList)) {
              item.areaList.forEach(areaObj => {
                if (areaObj.area) {
                  areas.push(areaObj.area);
                }
              });
            }
          });
        }

        if (areas.length > 0) {
          this.setState({ areas });
        } else {
          this.useFallbackAreas();
        }
      } else {
        this.useFallbackAreas();
      }
    } catch (err) {
      console.error('Error fetching areas:', err);
      this.useFallbackAreas();
    }
  }

  useFallbackAreas = () => {
    this.setState({
      areas: []
    });
  }

  fetchCourses = async () => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*',
        }
      };

      const coursesUrl = apis.getCoursesUrl(clientConfig);
      const res = await HELPERS.ApiCall(coursesUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data) {
        const courseList = res.data.data || res.data;
        const courses = [];

        if (Array.isArray(courseList)) {
          courseList.forEach(item => {
            if (item.master_course) {
              courses.push(item.master_course);
            }
          });
        }

        if (courses.length > 0) {
          this.setState({ courses });
        } else {
          this.useFallbackCourses();
        }
      } else {
        this.useFallbackCourses();
      }
    } catch (err) {
      console.error('Error fetching courses:', err);
      this.useFallbackCourses();
    }
  }

  useFallbackCourses = () => {
    const { clientConfig } = this.state;
    if (clientConfig && clientConfig.courses) {
      this.setState({ courses: clientConfig.courses });
    }
  }

  showMessage = (type, message) => {
    Toast(message, toastMsgConfig(type));
  }

  handleInputChange = (field, value) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [field]: value
      },
      errors: {
        ...this.state.errors,
        [field]: ''
      }
    });
  }

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = 'Full name is required';
    } else if (formData.name.trim().length < 2) {
      errors.name = 'Name must be at least 2 characters';
    }

    if (!formData.phone.trim()) {
      errors.phone = 'Phone number is required';
    } else if (!/^[0-9]{10}$/.test(formData.phone.replace(/\s/g, ''))) {
      errors.phone = 'Please enter a valid 10-digit phone number';
    }

    if (formData.email.trim() && !HELPERS.validateEmail(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }

    if (!formData.course) {
      errors.course = 'Please select a program of interest';
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  }

  handleSubmit = async () => {
    this.setState({ disabled: true });

    // Check rate limiting - max 3 submissions per minute
    if (!HELPERS.checkRateLimit('form_submission', 3, 60000)) {
      this.setState({ disabled: false });
      this.showMessage('e', 'Too many submissions. Please wait a minute before trying again.');
      return;
    }

    if (!this.validateForm()) {
      this.setState({ disabled: false });
      this.showMessage('e', 'Please correct the errors in the form');
      return;
    }

    this.setState({ loader: true });

    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Authorization': clientConfig.api.authorization,
          'Content-Type': 'application/json',
          'source': 'WEB',
          'accept': 'application/json, text/plain, */*'
        }
      };

      const payload = {
        name: this.state.formData.name,
        mobile: this.state.formData.phone,
        email: this.state.formData.email || '',
        comments: this.state.formData.message || 'Enquiry from modern form',
        institute_id: clientConfig.instituteId,
        customComponentList: [],
        mCourseName: this.state.formData.course || '',
        state: clientConfig.api.defaults.state,
        city: clientConfig.api.defaults.city,
        area: this.state.formData.area || clientConfig.api.defaults.defaultArea
      };

      const apiUrl = apis.getApiUrl(clientConfig);
      const res = await HELPERS.ApiCall(apiUrl, payload, 'POST', 'proctur', headers);

      if (res.status === 200 && res.data.statusCode === 200) {
        this.setState({
          loader: false,
          formData: {
            name: '',
            phone: '',
            email: '',
            area: '',
            course: '',
            message: ''
          },
          disabled: false,
          errors: {},
          currentStep: 1
        });
        this.showMessage('s', 'Registration submitted successfully! Our admissions team will contact you within 24 hours.');
      } else {
        this.showMessage('e', res.data.message || 'Something went wrong. Please try again.');
        this.setState({ loader: false, disabled: false });
      }
    } catch (err) {
      if (err.response && err.response.status === 403) {
        this.props.dispatch({
          type: 'LOGOUT',
          message: err.response.data?.message || 'Session expired'
        });
      } else {
        this.showMessage('e', ErrorMessageHandling(err));
      }
      this.setState({ loader: false, disabled: false });
    }
  }

  dismissWelcome = () => {
    this.setState({ showWelcome: false });
  }

  render() {
    const { formData, errors, disabled, loader, areas, courses, clientConfig, showWelcome } = this.state;

    if (!clientConfig) {
      return null;
    }

    return (
      <>
        {loader && (
          <div className="template12-loader">
            <div className="template12-loading-spinner"></div>
            <p>Submitting your enquiry...</p>
          </div>
        )}
        <ToastMessage />

        <div className="template12-app">
          {/* App Header - Sticky */}
          <header className="template12-header">
            <div className="template12-header-content">
              <div className="template12-logo">
                <img src={clientConfig.branding.logo} alt={clientConfig.clientName} />
              </div>
              <div className="template12-header-info">
                <h1>{clientConfig.clientName}</h1>
                <span className="template12-badge">{clientConfig.branding.badgeText}</span>
              </div>
            </div>
          </header>

          {/* Welcome Banner - Dismissible */}
          {showWelcome && (
            <div className="template12-welcome-banner">
              <button className="template12-dismiss" onClick={this.dismissWelcome}>
                <i className="fa fa-times"></i>
              </button>
              <div className="template12-welcome-content">
                <i className="fa fa-graduation-cap template12-welcome-icon"></i>
                <div className="template12-welcome-text">
                  <h3>{clientConfig.branding.heroTitle}</h3>
                  <p>{clientConfig.branding.heroSubtitle}</p>
                </div>
              </div>
            </div>
          )}

          {/* Stats Cards */}
          <div className="template12-stats-section">
            <div className="template12-stat-card">
              <div className="template12-stat-icon">
                <i className="fa fa-users"></i>
              </div>
              <div className="template12-stat-info">
                <span className="template12-stat-value">{clientConfig.stats.alumni}</span>
                <span className="template12-stat-label">Students</span>
              </div>
            </div>
            <div className="template12-stat-card">
              <div className="template12-stat-icon">
                <i className="fa fa-clock"></i>
              </div>
              <div className="template12-stat-info">
                <span className="template12-stat-value">{clientConfig.stats.experience}</span>
                <span className="template12-stat-label">Years</span>
              </div>
            </div>
            <div className="template12-stat-card">
              <div className="template12-stat-icon">
                <i className="fa fa-briefcase"></i>
              </div>
              <div className="template12-stat-info">
                <span className="template12-stat-value">{clientConfig.stats.placement}</span>
                <span className="template12-stat-label">Placement</span>
              </div>
            </div>
            <div className="template12-stat-card">
              <div className="template12-stat-icon">
                <i className="fa fa-handshake"></i>
              </div>
              <div className="template12-stat-info">
                <span className="template12-stat-value">{clientConfig.stats.partners}</span>
                <span className="template12-stat-label">Partners</span>
              </div>
            </div>
          </div>

          {/* Main Content Container */}
          <div className="template12-content">
            {/* Registration Form Card */}
            <div className="template12-form-card">
              <div className="template12-form-header">
                <i className="fa fa-edit"></i>
                <h2>Student Registration</h2>
                <p>Fill in your details to get started</p>
              </div>

              <form className="template12-form" onSubmit={(e) => e.preventDefault()}>
                {/* Personal Information */}
                <div className="template12-section">
                  <div className="template12-section-title">
                    <i className="fa fa-user"></i>
                    <span>Personal Information</span>
                  </div>

                  <div className="template12-input-group">
                    <label className="template12-label">
                      Full Name <span className="template12-required">*</span>
                    </label>
                    <div className="template12-input-wrapper">
                      <i className="fa fa-user template12-input-icon"></i>
                      <input
                        type="text"
                        className={`template12-input ${errors.name ? 'template12-error' : ''}`}
                        placeholder="Enter your full name"
                        value={formData.name}
                        onChange={(e) => this.handleInputChange('name', e.target.value)}
                      />
                    </div>
                    {errors.name && (
                      <span className="template12-error-text">
                        <i className="fa fa-exclamation-circle"></i> {errors.name}
                      </span>
                    )}
                  </div>

                  <div className="template12-row">
                    <div className="template12-input-group">
                      <label className="template12-label">
                        Phone Number <span className="template12-required">*</span>
                      </label>
                      <div className="template12-input-wrapper">
                        <i className="fa fa-phone template12-input-icon"></i>
                        <input
                          type="tel"
                          className={`template12-input ${errors.phone ? 'template12-error' : ''}`}
                          placeholder="10-digit mobile"
                          value={formData.phone}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, '');
                            if (value.length <= 10) {
                              this.handleInputChange('phone', value);
                            }
                          }}
                        />
                      </div>
                      {errors.phone && (
                        <span className="template12-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.phone}
                        </span>
                      )}
                    </div>

                    <div className="template12-input-group">
                      <label className="template12-label">Email Address</label>
                      <div className="template12-input-wrapper">
                        <i className="fa fa-envelope template12-input-icon"></i>
                        <input
                          type="email"
                          className={`template12-input ${errors.email ? 'template12-error' : ''}`}
                          placeholder="your@email.com"
                          value={formData.email}
                          onChange={(e) => this.handleInputChange('email', e.target.value)}
                        />
                      </div>
                      {errors.email && (
                        <span className="template12-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.email}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Program Selection */}
                <div className="template12-section">
                  <div className="template12-section-title">
                    <i className="fa fa-graduation-cap"></i>
                    <span>Program Details</span>
                  </div>

                  <div className="template12-input-group">
                    <label className="template12-label">
                      Select Course <span className="template12-required">*</span>
                    </label>
                    <div className="template12-input-wrapper">
                      <i className="fa fa-book template12-input-icon"></i>
                      <select
                        className={`template12-input template12-select ${errors.course ? 'template12-error' : ''}`}
                        value={formData.course}
                        onChange={(e) => this.handleInputChange('course', e.target.value)}
                      >
                        <option value="">Choose your program</option>
                        {courses.map((course, index) => (
                          <option key={index} value={course}>
                            {course}
                          </option>
                        ))}
                      </select>
                    </div>
                    {errors.course && (
                      <span className="template12-error-text">
                        <i className="fa fa-exclamation-circle"></i> {errors.course}
                      </span>
                    )}
                  </div>

                  {areas.length > 0 && (
                    <div className="template12-input-group">
                      <label className="template12-label">Location / Area</label>
                      <div className="template12-input-wrapper">
                        <i className="fa fa-map-marker template12-input-icon"></i>
                        <select
                          className="template12-input template12-select"
                          value={formData.area}
                          onChange={(e) => this.handleInputChange('area', e.target.value)}
                        >
                          <option value="">Select your area</option>
                          {areas.map((area, index) => (
                            <option key={index} value={area}>
                              {area}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}

                  <div className="template12-input-group">
                    <label className="template12-label">Additional Information</label>
                    <div className="template12-input-wrapper">
                      <i className="fa fa-comment template12-input-icon"></i>
                      <textarea
                        className="template12-input template12-textarea"
                        placeholder="Tell us about your interests, goals, or any questions..."
                        rows="4"
                        value={formData.message}
                        onChange={(e) => this.handleInputChange('message', e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <button
                  type="button"
                  className={`template12-submit-btn ${disabled ? 'template12-disabled' : ''}`}
                  onClick={this.handleSubmit}
                  disabled={disabled}
                >
                  {loader ? (
                    <>
                      <i className="fa fa-spinner fa-spin"></i>
                      Submitting...
                    </>
                  ) : (
                    <>
                      <i className="fa fa-paper-plane"></i>
                      Submit Registration
                    </>
                  )}
                </button>

                <div className="template12-form-footer">
                  <i className="fa fa-shield"></i>
                  <span>Your information is secure and confidential</span>
                </div>
              </form>
            </div>

            {/* Features Section */}
            <div className="template12-features-card">
              <h3>Why Choose Us?</h3>
              <div className="template12-features-list">
                {clientConfig.features.map((feature, index) => (
                  <div key={index} className="template12-feature-item">
                    <i className="fa fa-check-circle"></i>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Contact Info Card */}
            <div className="template12-contact-card">
              <h3>Get in Touch</h3>
              <div className="template12-contact-list">
                <a href={`tel:${clientConfig.contactInfo.phone1}`} className="template12-contact-item">
                  <div className="template12-contact-icon">
                    <i className="fa fa-phone"></i>
                  </div>
                  <div className="template12-contact-details">
                    <span className="template12-contact-label">Call Us</span>
                    <span className="template12-contact-value">{clientConfig.contactInfo.phone1}</span>
                  </div>
                </a>

                <a href={`mailto:${clientConfig.contactInfo.email}`} className="template12-contact-item">
                  <div className="template12-contact-icon">
                    <i className="fa fa-envelope"></i>
                  </div>
                  <div className="template12-contact-details">
                    <span className="template12-contact-label">Email</span>
                    <span className="template12-contact-value">{clientConfig.contactInfo.email}</span>
                  </div>
                </a>

                <div className="template12-contact-item">
                  <div className="template12-contact-icon">
                    <i className="fa fa-map-marker"></i>
                  </div>
                  <div className="template12-contact-details">
                    <span className="template12-contact-label">Address</span>
                    <span className="template12-contact-value">{clientConfig.contactInfo.address}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Navigation (Mobile) */}
          <div className="template12-bottom-nav">
            <a href={`tel:${clientConfig.contactInfo.phone1}`} className="template12-nav-item">
              <i className="fa fa-phone"></i>
              <span>Call</span>
            </a>
            <a href={`mailto:${clientConfig.contactInfo.email}`} className="template12-nav-item">
              <i className="fa fa-envelope"></i>
              <span>Email</span>
            </a>
            <a href={`https://${clientConfig.contactInfo.website}`} target="_blank" rel="noopener noreferrer" className="template12-nav-item">
              <i className="fa fa-globe"></i>
              <span>Website</span>
            </a>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  ...state.home,
  ...state.auth
});

const ConnectedEnquiryTemplate12 = connect(mapStateToProps)(EnquiryTemplate12);

function EnquiryTemplate12WithRouter(props) {
  const { clientId } = useParams();
  return <ConnectedEnquiryTemplate12 {...props} clientId={clientId} />;
}

export default EnquiryTemplate12WithRouter;
